const ip = '';//http://121.127.226.165:2000
const http = ip + "/api/v1/"
const path = {
    ip: ip,
    login: http + 'admin/login',
    logout: http + 'admin/logout',
    home: http + 'admin/home',
    system: http + 'admin/config',
    order_text_tip: http + 'admin/order_status',
    user: http + 'admin/members/list',
    user_search: http + 'admin/members/search',
    user_del: http + 'admin/members/del',
    user_lock: http + 'admin/members/lock',
    user_det: http + 'admin/members/detail',
    user_edit: http + 'admin/members/edit',
    user_billing: http + 'admin/members/billing',
    agent:http + 'admin/agent/list',
    agent_add:http + 'admin/agent/add',
    agent_detail:http + 'admin/agent/detail',
    agent_del:http + 'admin/agent/delAgent',
    kefu:http + 'admin/kefu/list',
    kefu_add:http + 'admin/kefu/add',
    kefu_detail:http + 'admin/kefu/detail',
    kefu_del:http + 'admin/kefu/delKefu',
    invite_code:http + 'admin/invite_code/list',
    invite_code_add:http + 'admin/invite_code/add',
    change_vip_level: http + 'admin/members/change_vip_level',
    agreement: http + 'admin/config/agreement',
    upload: http + 'upload',
    borrow: http + 'admin/order/list',
    borrow_del: http + 'admin/order/delete',
    change_status: http + 'admin/order/change_status',
    change_status: http + 'admin/order/change_status',
    widthdraw_reject: http + 'admin/order/widthdraw_reject',
    borrow_edit_money: http + 'admin/order/edit_money',
    widthdraw_enabled: http + 'admin/members/withdraw_enabled',
    admin: http + 'admin/sub_account/list',
    admin_del: http + 'admin/sub_account/del',
    admin_add: http + 'admin/sub_account/add',
    admin_det: http + 'admin/sub_account/detail',
    admin_edit: http + 'admin/sub_account/edit',
    edit: http + 'admin/members/edit',
    transfer_screenshot: http + 'admin/order/transfer_screenshot',
    contact: http + 'admin/order/contact',
    user_add: http + 'admin/members/add',
    restpass: http + 'admin/members/restpass'
}
export default path;



// WEBPACK FOOTER //
// ./src/common/config.js